import Formatter from '../Formatter/Formatter';
class NFT {
  constructor({
    id,
    _id,
    is_sbt,
    name,
    blockchain = {},
    ipfs = {},
    certificate,
    image_project,
    name_project,
  }) {
    this.id = id || _id;
    this.name = name;
    this.blockchain = blockchain;
    this.ipfs = ipfs;
    this.is_sbt = is_sbt;
    this.certificate = certificate;
    this.image_project = image_project;
    this.name_project = name_project;
  }
  get truncateHashIPFS() {
    return Formatter.truncateString(this.ipfs.hash, 20);
  }
  get truncateHashBlockchain() {
    return Formatter.truncateString(this.blockchain.hash, 20);
  }
  static hasCertificate(nft) {
    return nft.certificate !== null;
  }
}

export default NFT;
